
import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {NgControl} from '@angular/forms';
import {isNullOrUndefined} from 'util'

@Directive({
  selector: '[appFloatwithMinmax]'
})
export class FloatwithMinmaxDirective {
  allowedDecimal = 2;
  @Input() min:number;
  @Input() max:number;
  constructor(private ngControl: NgControl,private toastr : ToastrService) {}

@HostListener('input', ['$event.target.value'])
onInput(value: string) {
  let clean = '';
  clean = value.replace(/[^0-9\.]/g, '');
  const decimalCheck = clean.split('.');
  if (!isNullOrUndefined(decimalCheck[1])) {
    if (decimalCheck[1].length > this.allowedDecimal) {
      // toastr.clear()
      // toastr.error("More than 2 Decimals are Not Allowed")
    }
    decimalCheck[1] = decimalCheck[1].slice(0, this.allowedDecimal);
    if (isNullOrUndefined(decimalCheck[0])  || decimalCheck[0] === '') {
      decimalCheck[0] = '0';
    }
    clean = decimalCheck[0] + '.' + decimalCheck[1];
    }
    if(this.min && parseFloat(clean) < this.min){
      clean = ''
      this.toastr.error('the entered number should be greater than min value');
    }  if(this.max && parseFloat(clean) > this.max){
      clean = ''
      this.toastr.error('the entered number should be less than max value');
    }
    this.ngControl.control.patchValue(clean);
  }
}


